import Cookies from "js-cookie";

const TOKEN_KEY = "suit_token";
const DOMAIN = ".zentixs.com"; // shared across subdomains

const getEnvConfig = (): { isLocal: boolean; isHttps: boolean } => {
  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1";
  const isHttps = window.location.protocol === "https:";

  return { isLocal, isHttps };
};

/** Store SSO token in cookie */
export const setToken = (token: string): void => {
  const { isLocal, isHttps } = getEnvConfig();

  Cookies.set(TOKEN_KEY, token, {
    path: "/",
    domain: isLocal ? undefined : DOMAIN,
    sameSite: isHttps ? "none" : "lax",
    secure: isHttps,
    expires: 1,
  });
};

/** Remove SSO token */
export const clearToken = (): void => {
  const { isLocal, isHttps } = getEnvConfig();

  Cookies.remove(TOKEN_KEY, {
    path: "/",
    domain: isLocal ? undefined : DOMAIN,
    secure: isHttps,
  });
};

/** Get current SSO token */
export const getToken = (): string | null => {
  return Cookies.get(TOKEN_KEY) || null;
};

/** Check if user is logged in */
export const isLoggedIn = (): boolean => {
  return !!getToken();
};